import React, { useState, useEffect, Fragment } from "react";
import services from "../services";
import { BagQRPrintFilteringSchema } from "../CardSchema";
import { BagQRPrintListing } from "./listing";
import { PageHeader } from "../../../Common";
import { validateProperty, validate } from "../../Common";
import Joi from "@hapi/joi";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import FormHelperText from "@material-ui/core/FormHelperText";
import authService from "../../Common/services";
import tokenService from "../../../Common/tokenDecoder";
import { trackPromise } from "react-promise-tracker";
import { LoadingSpinerComponent } from "../../../Common/loader";

const screenCode = "BAGQRCODEREPRINT";

export function BagQRPrintFiltering(props) {
  const [groups, setGroups] = useState([]);
  const [operationEntity, setOperationEntity] = useState([]);
  const [collectionPoint, setCollectionPoint] = useState([]);
  const [bagQRTags, setBagQRTags] = useState([]);
  const [multipleEstates, setMultipleEstates] = useState([]);
  const [bagQRPrintFilter, setBagQRPrintFilter] = useState({
    groupID: "0",
    operationEntityID: "0",
    collectionPointID: "0",
  });
  const [errors, setErrors] = useState({});
  const [permissionList, setPermissions] = useState({
    isGroupFilterEnabled: false,
    isOperationEntityFilterEnabled: false,
  });

  const schema = Joi.object(BagQRPrintFilteringSchema).options({
    allowUnknown: true,
  });

  useEffect(() => {
    trackPromise(getPermissions());
  }, []);

  useEffect(() => {
    if (bagQRPrintFilter.groupID !== "0") {
      trackPromise(getOperationEntityForDropdown());
    }
  }, [bagQRPrintFilter.groupID]);

  useEffect(() => {
    if (bagQRPrintFilter.operationEntityID !== "0") {
      trackPromise(getCollectionPointForDropDown());
    }
  }, [bagQRPrintFilter.operationEntityID]);

  useEffect(() => {
    setBagQRTags([]);
  }, [
    bagQRPrintFilter.groupID,
    bagQRPrintFilter.operationEntityID,
    bagQRPrintFilter.collectionPointID,
  ]);

  async function getGroupsForDropdown() {
    const result = await services.getAlGroupsForDropdown();
    setGroups(result);
  }

  async function getOperationEntityForDropdown() {
    const operationEntityList = await services.getOperationEntitiesByGroupForDropDown(
      bagQRPrintFilter.groupID
    );
    setOperationEntity(operationEntityList);
  }

  async function getCollectionPointForDropDown() {
    const collectionPointList = await services.GetCollectionPointsFilter(
      bagQRPrintFilter.operationEntityID
    );
    setCollectionPoint(collectionPointList);
  }

  async function getPermissions() {
    var permissions = await authService.getPermissionsByScreen(screenCode);
    var isAuthorized = permissions.find(
      (p) => p.permissionCode == "BAGQRCODEREPRINT"
    );

    if (isAuthorized === undefined) {
      props.history.push("/unauthorized");
    }

    var isGroupFilterEnabled = permissions.find(
      (p) => p.permissionCode == "GROUPDROPDOWN"
    );
    var isOperationEntityFilterEnabled = permissions.find(
      (p) => p.permissionCode == "OPERATIONENTITYDROPDOWN"
    );

    setPermissions({
      ...permissionList,
      isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
      isOperationEntityFilterEnabled: isOperationEntityFilterEnabled !== undefined,
    });

    var token = tokenService.getUserDetailsFromTokenV2();
    if (token.operationEntities.length > 0) {
      var estateArray = [];
      for (let item of Object.entries(token.operationEntities)) {
        estateArray[item[1]["OperationEntityID"]] = item[1]["OperationEntityName"];
      }
      setMultipleEstates(estateArray);
    }

    setBagQRPrintFilter({
      ...bagQRPrintFilter,
      groupID: token.groupID,
      operationEntityID: token.operationEntityID,
    });

    trackPromise(getGroupsForDropdown());
  }

  function handleGroupChange(target) {
    validateInputs(target);

    setBagQRPrintFilter({
      ...bagQRPrintFilter,
      groupID: target.value,
      operationEntityID: "0",
      collectionPointID: "0",
    });
  }

  function handleOperationEntityChange(target) {
    validateInputs(target);

    setBagQRPrintFilter({
      ...bagQRPrintFilter,
      operationEntityID: target.value,
      collectionPointID: "0",
    });
  }

  function handleCollectionPointChange(target) {
    validateInputs(target);

    setBagQRPrintFilter({
      ...bagQRPrintFilter,
      collectionPointID: target.value,
    });
  }

  function validateInputs(target) {
    const error = { ...errors };
    const errorMessage = validateProperty(target, BagQRPrintFilteringSchema);
    errorMessage
      ? (error[target.name] = errorMessage)
      : delete error[target.name];

    setErrors(error);
  }

  async function handleSearch(e) {
    e.preventDefault();
    const errorMessages = validate(schema, bagQRPrintFilter);
    errorMessages !== null ? setErrors(errorMessages) : setErrors({});
    if (errorMessages) return;

    const response = await services.getGeneratedBagQRTags(
      getSelectedGroupName(),
      getSelectedEstateName(),
      getSelectedDivisionName()
    );
    setBagQRTags(response);
  }

  function getSelectedGroupName() {
    return bagQRPrintFilter.groupID || "";
  }

  function getSelectedEstateName() {
    return bagQRPrintFilter.operationEntityID || "";
  }

  function getSelectedDivisionName() {
    return bagQRPrintFilter.collectionPointID === "0"
      ? ""
      : bagQRPrintFilter.collectionPointID || "";
  }

  function generateDropDownMenu(data) {
    let items = [];
    if (data != null) {
      for (const [key, value] of Object.entries(data)) {
        items.push(
          <MenuItem key={key} value={key}>
            {value}
          </MenuItem>
        );
      }
    }
    return items;
  }

  async function afterSuccessfulyChanged() {
    setBagQRTags([]);
    const response = await services.getGeneratedBagQRTags(
      getSelectedGroupName(),
      getSelectedEstateName(),
      getSelectedDivisionName()
    );
    setBagQRTags(response);
  }

  function clearState() {
    setBagQRPrintFilter({
      ...bagQRPrintFilter,
      collectionPointID: "0",
    });
    setBagQRTags([]);
  }

  return (
    <Fragment>
      <LoadingSpinerComponent />
      <div className="row">
        <div className="col-md-12">
          <div className="card">
            <div className="card-body">
              <PageHeader
                title="Bag QR Code Re Print"
              />
              <form onSubmit={(e) => handleSearch(e)} disabled={false}>
                <div className="form-group row">
                  <div className="col-md pb-1">
                    <InputLabel shrink id="groupID">
                      Group *
                    </InputLabel>
                    <Select
                      fullWidth
                      id="groupID"
                      name="groupID"
                      value={bagQRPrintFilter.groupID}
                      disabled={!permissionList.isGroupFilterEnabled}
                      onChange={(e) => handleGroupChange(e.target)}
                    >
                      <MenuItem value="0">--Select Group--</MenuItem>
                      {generateDropDownMenu(groups)}
                    </Select>
                    {errors["groupID"] && (
                      <FormHelperText error>{errors["groupID"]}</FormHelperText>
                    )}
                  </div>

                  <div className="col-md pb-1">
                    <InputLabel shrink id="operationEntityID">
                      Operation Entity *
                    </InputLabel>
                    <Select
                      fullWidth
                      id="operationEntityID"
                      name="operationEntityID"
                      value={bagQRPrintFilter.operationEntityID}
                      disabled={!permissionList.isOperationEntityFilterEnabled}
                      onChange={(e) => handleOperationEntityChange(e.target)}
                    >
                      <MenuItem value="0">--Select Operation Entity--</MenuItem>
                      {generateDropDownMenu(
                        Object.fromEntries(
                          Object.entries(operationEntity).filter(([key, value]) => {
                            if (key === "0" || !value) return false;
                            if (!multipleEstates || Object.keys(multipleEstates).length === 0) {
                              return true;
                            }
                            return Object.values(multipleEstates).includes(value);
                          })
                        )
                      )}
                    </Select>
                    {errors["operationEntityID"] && (
                      <FormHelperText error>
                        {errors["operationEntityID"]}
                      </FormHelperText>
                    )}
                  </div>

                  <div className="col-md">
                    <InputLabel shrink id="collectionPointID">
                      Collection Point
                    </InputLabel>
                    <Select
                      fullWidth
                      id="collectionPointID"
                      name="collectionPointID"
                      value={bagQRPrintFilter.collectionPointID}
                      onChange={(e) => handleCollectionPointChange(e.target)}
                    >
                      <MenuItem value="0">--All Collection Points--</MenuItem>
                      {generateDropDownMenu(collectionPoint)}
                    </Select>
                    {errors["collectionPointID"] && (
                      <FormHelperText error>
                        {errors["collectionPointID"]}
                      </FormHelperText>
                    )}
                  </div>
                </div>

                <div className="card-footer">
                  <input
                    type="submit"
                    className="btn btn-primary"
                    value="Search"
                  />
                  <input
                    type="button"
                    className="btn btn-warning pull-right"
                    value="Clear"
                    onClick={clearState}
                  />
                </div>

                <BagQRPrintListing
                  bagQRTags={bagQRTags}
                  afterSuccessfulyChanged={afterSuccessfulyChanged}
                />
              </form>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
}
